export const messagesApi = {
    // api: the authenticated axios instance from useAuth()
    getConversations: async (api, hotelId, page = 1, limit = 20) => {
        try {
            // Include hotelId in query parameter for multi-tab safety
            const response = await api.get(`/conversations?hotelId=${hotelId}&page=${page}&limit=${limit}`);
            const rows = response.data;

            // Map backend response to the structure expected by the UI
            const conversations = rows.map(row => ({
                user: {
                    id: row.user_id,
                    // row.user is the display name (first + last name or fallback to user_id)
                    name: row.user ? row.user : 'Unknown',
                    avatar: null
                },
                lastMessage: {
                    message: row.message,
                    created_on: row.created_on,
                    role: row.role,
                    output_english: row.output_english,
                    output_original: row.output_original,
                    user_input_english: row.user_input_english,
                    user_input_original: row.user_input_original
                },
                unreadCount: 0, // Backend doesn't provide unread count yet
                messages: undefined
            }));

            return {
                data: conversations,
                // Heuristic: if we got fewer items than the limit, we reached the end.
                // If backend ignores limit and always returns 10, this might be inaccurate if total is exactly multiple of 10.
                hasMore: rows.length >= limit,
                total: 0 // Total count not provided by backend
            };
        } catch (error) {
            console.error("Error fetching conversations:", error);
            throw error;
        }
    },

    // Fetches conversations across ALL properties the user has access to.
    getAllConversations: async (api, page = 1, limit = 20) => {
        try {
            const response = await api.get(`/conversations/all?page=${page}&limit=${limit}`);
            const rows = response.data;

            const conversations = rows.map(row => ({
                user: {
                    id: row.user_id,
                    name: row.user ? row.user : 'Unknown',
                    avatar: null
                },
                property: {
                    id: row.hotel_id,
                    name: row.hotel_name || `Property ${row.hotel_id}`
                },
                lastMessage: {
                    message: row.message,
                    created_on: row.created_on,
                    role: row.role,
                    output_english: row.output_english,
                    output_original: row.output_original,
                    user_input_english: row.user_input_english,
                    user_input_original: row.user_input_original
                },
                unreadCount: 0,
                messages: undefined
            }));

            return {
                data: conversations,
                hasMore: rows.length >= limit,
                total: 0
            };
        } catch (error) {
            console.error("Error fetching all conversations:", error);
            throw error;
        }
    },

    // api: the authenticated axios instance from useAuth()
    getMessages: async (api, userId, hotelId) => {
        try {
            const response = await api.get(`/messages/${userId}?hotelId=${hotelId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching messages:", error);
            throw error;
        }
    }
};


